module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00025.b0c6871d.jpg";